import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
  input,
  ChangeDetectionStrategy
} from "@angular/core";

@Component({
  selector: "loren-file-upload",
  templateUrl: "./loren-file-upload.component.html",
  styleUrls: ["./loren-file-upload.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LorenFileUploadComponent {
  private static readonly BYTES_IN_KB = Math.pow(2, 10); // 1024

  allowedFileTypes = input<string>();
  fileSizeLimitInMb = input<number>();
  renderAsHidden = input<boolean>(true);
  customField = input<boolean>();
  id = input<string>();
  label = input<string>();
  @Output() fileSizeExceeded = new EventEmitter<void>();
  @Output() fileTypeMismatch = new EventEmitter<string>();
  @Output() successfulFileUpload = new EventEmitter<string>();
  @Output() successfulFileUploadWithNameAndSize = new EventEmitter<{
    file: string;
    name: string;
    size: number;
  }>();

  @ViewChild("file") fileInput: ElementRef;

  triggerFileInputClick() {
    this.fileInput.nativeElement.click();
  }

  onFileChanged($event) {
    const selectedFile = $event.target.files[0];
    if (selectedFile) {
      if (!this.isFileTypeAllowed(selectedFile)) {
        this.fileTypeMismatch.emit(selectedFile.name);
      } else {
        const sizeInMb =
          selectedFile.size / Math.pow(LorenFileUploadComponent.BYTES_IN_KB, 2);
        if (sizeInMb > this.fileSizeLimitInMb()) {
          this.fileSizeExceeded.emit();
        } else {
          const reader = new FileReader();
          reader.onload = (e) => {
            const fileBase64 = e.target.result as string;
            this.successfulFileUpload.emit(fileBase64);
            this.successfulFileUploadWithNameAndSize.emit({
              file: fileBase64,
              name: selectedFile.name,
              size: sizeInMb,
            });
          };

          reader.readAsDataURL(selectedFile);
        }
      }
    }
  }

  private isFileTypeAllowed(file: File): boolean {
    const extensionIndex = file.name.lastIndexOf(".");
    const fileType = file.name.substr(extensionIndex).toLowerCase();
    const allowedTypesArr = this.allowedFileTypes()
      .split(",")
      .map((x) => x.trim().toLowerCase());
    return allowedTypesArr.indexOf(fileType) !== -1;
  }
}
